import ListProducers from "@/views/organization/certifications/basic_certifications_producers/ListProducers.vue";
import ShowProducer from "@/views/organization/certifications/basic_certifications_producers/ShowProducer.vue";
import NewCropFieldCertification from "@/views/organization/certifications/basic_certifications_producers/NewCropFieldCertification.vue";
import EditCropFieldCertification from "@/views/organization/certifications/basic_certifications_producers/EditCropFieldCertification.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "certifications",
  permission: "basic_certifications_producers"
});

export default [
  {
    path: "/org/:organization_id/certifications/basic_certifications_producers",
    name: routeName(""),
    props: true,
    redirect: { name: routeName("list_producers") }
  },
  {
    path: "/org/:organization_id/certifications/basic_certifications_producers/list_producers",
    name: routeName("list_producers"),
    component: ListProducers,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/certifications/basic_certifications_producers/show_organization/:producer_id",
    name: routeName("show_producer"),
    component: ShowProducer,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/certifications/basic_certifications_producers/new_crop_field_certification/:producer_id",
    name: routeName("new_crop_field_certification"),
    component: NewCropFieldCertification,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/certifications/basic_certifications_producers/edit_crop_field_certification/:producer_id/:crop_field_certification_id",
    name: routeName("edit_crop_field_certification"),
    component: EditCropFieldCertification,
    props: true,
    meta: META
  }
];
